import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { PageState, PageStateModel } from './page.state';

@Injectable()
export class PageSelectors {
  @Selector([PageState])
  static page(state: PageStateModel) {
    return state.page;
  }

  @Selector([PageState])
  static pageHeaderHidden(state: PageStateModel) {
    return state.page?.hideHeader ?? false;
  }

  @Selector([PageState])
  static pageFooterHidden(state: PageStateModel) {
    return state.page?.hideFooter ?? false;
  }

  @Selector([PageState])
  static headerLogo(state: PageStateModel) {
    return state.page?.headerLogo;
  }
}
